import {useContext} from 'react';
import {useQuery} from '@tanstack/react-query';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {DropdownItemType} from '@/api/dto/dto';

export function useTaskStepName() {
  const { carecoApi } = useContext(CarecoApiContext);

  const { data: taskStepNames, isLoading: isLoadingTaskStepNames, error: errorTaskStepNames } = useQuery({
    queryKey: ['dropdownItems', [DropdownItemType.TASK_STEP_NAME]],
    queryFn: () => carecoApi?.getDropdownItems([DropdownItemType.TASK_STEP_NAME]),
    enabled: !!carecoApi,
  });

  const taskStepDisplayValues: Record<string, string> = taskStepNames?.reduce((map, taskStepName) =>
    ({ ...map, [taskStepName.value]: taskStepName.label }), {}) ?? {};

  return {
    taskStepDisplayValues,
    isLoadingTaskStepNames,
    errorTaskStepNames,
  };
}
